import { z } from "zod";

export const goLiveSchema = z.object({
  zone_id: z.string().min(1, "Zone is required"),
});

export type GoLiveInput = z.infer<typeof goLiveSchema>;
